import { LoquixDisclosureBadge } from './loquix-disclosure-badge.js';

if (!customElements.get('loquix-disclosure-badge')) {
  customElements.define('loquix-disclosure-badge', LoquixDisclosureBadge);
}
